import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { CommonModule } from '@angular/common'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { ShowModalRoutingModule } from './show-modal-routing.module'
import { OrganizationService } from '../organization.service'
import { OrganizationDocumentService } from '../organization-document.service'
import { OrganizationSerializer } from '../organization.serializer'
import { OrganizationRequiredSubscriptionService } from '../organization-required-subscription.service'
import { OrganizationEffects } from '../organization.effects'
import * as fromOrganization from '../organization.reducer'
import { OrganizationRelationEffects } from '../organization-relation.effects'
import { SaleModule } from '../../sale/sale.module'
import { SubscriptionModule } from '../../subscription/subscription.module'
import { DocumentModule } from '../../document/document.module'
import { ActivityModule } from '../../activity/activity.module'
import { AddressModule } from '../../address/address.module'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { RoleModule } from '../../role/role.module'
import { CommonComponentsModule } from 'src/app/common-components/common-components.module'
import { UserRoleModule } from '../../role/user-role/user-role.module'
@NgModule({
  imports: [
    StoreModule.forFeature(
      fromOrganization.FEATURE_NAME,
      fromOrganization.organizationReducer
    ),
    EffectsModule.forFeature([
      OrganizationEffects,
      OrganizationRelationEffects
    ]),
    TooltipModule.forRoot(),
    ShowModalRoutingModule,
    CommonModule,
    SaleModule,
    SubscriptionModule,
    DocumentModule,
    ActivityModule,
    AddressModule,
    NzDatePickerModule,
    RoleModule,
    UserRoleModule,
    CommonComponentsModule
  ],
  providers: [
    OrganizationService,
    OrganizationDocumentService,
    {
      provide: OrganizationSerializer,
      useClass: OrganizationSerializer
    },
    OrganizationRequiredSubscriptionService
  ]
})
export class ShowModalModule {}
